import * as z from "zod";

/**
 * Something a team can have switched on, and the only thing a settings gate may
 * check. Products, billing line items and onboarding offerings group these.
 */
export const Capability = z.enum([
  "ai",
  "aeo",
  "checkoutOptimization",
  "contextual",
  "customerAccounts",
  "disputes",
  "emailSms",
  "hsa",
  "ims",
  "landedCost",
  "oms",
  "orderEditing",
  "orderTracking",
  "packageProtection",
  "predictiveConversion",
  "recover",
  "recycling",
  "redoManagedReturns",
  "returns",
  "reviews",
  "supplies",
  "support",
  "tnpl",
  "warranties",
  "withdrawals",
  "wms",
]);
export type Capability = z.infer<typeof Capability>;
